import React from "react";
// mui
import { TextField, TextFieldProps } from "@mui/material";
import { UseFormRegisterReturn } from "react-hook-form";

type TProps = {
  name: string;
  label: string;
  type: string;
  register: UseFormRegisterReturn;
  errorMessage: string | undefined;
  // Shown as helper text under the field when there's no validation error.
  // An error always takes priority over this.
  description?: string;
  multiline?: boolean;
  minRows?: number;
  rows?: number;
  maxRows?: number;
  defaultValue?: any;
  disabled?: boolean;
  styles?: any;
  readOnly?: boolean;
  step?: number;
  placeholder?: string;
};
const InputField = ({
  name,
  label,
  register,
  type,
  errorMessage,
  description,
  multiline,
  minRows,
  rows,
  maxRows,
  defaultValue,
  disabled = false,
  styles,
  readOnly = false,
  step = 0.01,
  placeholder,
}: TProps) => {
  return (
    <TextField
      id={name}
      type={type}
      label={label}
      {...register}
      placeholder={placeholder}
      error={errorMessage ? true : false}
      helperText={errorMessage || description}
      multiline={multiline}
      minRows={minRows}
      maxRows={maxRows}
      rows={rows}
      defaultValue={defaultValue}
      disabled={disabled}
      sx={styles}
      inputProps={{
        step: step,
        readOnly: readOnly,
      }}
      InputLabelProps={{
        shrink: type == "date" || type == "datetime-local" ? true : undefined,
      }}
    />
  );
};

export default InputField;
